<template>
	<ul class="icon-list">
		<li>
			<TnIcon name="60-day-free-returns" />
			<span class="text">60 dagers åpent kjøp på mobil</span>
		</li>
		<li>
			<TnIcon name="free-delivery-and-returns" />
			<span class="text">Fri frakt og retur</span>
		</li>
		<li>
			<TnIcon name="express-delivery" />
			<span class="text">Rask levering</span>
		</li>
		<li>
			<TnIcon name="pick-up" />
			<span class="text">Klikk & Hent</span>
		</li>
	</ul>
</template>

<script>
export default defineNuxtComponent({
	name: "ECommerceUSP",
});
</script>

<style lang="scss" scoped>
.icon-list {
	width: 100%;
	display: flex;
	justify-content: center;

	svg {
		width: auto;
		height: 21px;
	}

	li {
		display: inline-flex;
		align-items: center;

		@include font-text-bold-xs;

		+ li {
			margin-left: $spacing-l;
		}

		.icon {
			display: inline-block;
			width: 21px;
		}

		:deep(img) {
			width: auto;
			height: 21px;
			vertical-align: middle;
		}

		.text {
			padding-left: $spacing-s;
		}
	}

	@media (max-width: $size-screen-s) {
		display: none;
	}
}
</style>
